export default "__VITE_ASSET__8c1c99b5__"